// Pagination component styles
export const PAGINATION_STYLES = {
  container: {
    alignItems: "center",
    gap: 3,
    bg: "white",
    p: 1.5,
    borderRadius: "xl",
    border: "1px solid",
    borderColor: "gray.200",
    boxShadow: "sm",
    flexShrink: 0
  },
  button: {
    size: "sm",
    fontSize: "14px",
    fontWeight: "600",
    variant: "outline",
    borderColor: "gray.300",
    color: "gray.600",
    bg: "white",
    transition: "all 0.2s ease",
    borderRadius: "lg",
    px: 4,
    py: 2,
    height: "36px",
    _hover: {
      bg: "gray.50",
      borderColor: "gray.400",
      color: "gray.700",
      transform: "translateY(-1px)",
      boxShadow: "sm"
    },
    _active: {
      transform: "translateY(0)",
      bg: "gray.100"
    },
    _disabled: {
      opacity: 0.5,
      cursor: "not-allowed",
      _hover: {
        transform: "none",
        boxShadow: "none",
        bg: "white"
      }
    }
  },
  pageContainer: {
    display: "flex",
    alignItems: "center",
    bg: "gray.50",
    borderRadius: "lg",
    border: "1px solid",
    borderColor: "gray.200",
    px: 3,
    py: 1,
    minW: "120px",
    justifyContent: "center"
  },
  select: {
    size: "sm",
    width: "60px",
    variant: "unstyled",
    fontSize: "14px",
    fontWeight: "700",
    color: "blue.600",
    textAlign: "center",
    cursor: "pointer",
    _hover: { color: "blue.700" },
    _focus: { boxShadow: "none" }
  },
  text: {
    page: { fontSize: "13px", fontWeight: "600", color: "gray.600", mr: 2 },
    total: { fontSize: "13px", fontWeight: "500", color: "gray.500", ml: 1 }
  }
};
